import { Component, inject, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'fgb-marketplace-transfer-success-page',
  templateUrl: './marketplace-transfer-success-page.component.html',
  styleUrl: './marketplace-transfer-success-page.component.scss',
})
export class MarketplaceTransferSuccessPageComponent implements OnInit {
  transferDetails = JSON.parse(sessionStorage.getItem('transferSuccess') || '{}');
  private router = inject(Router);

  ngOnInit(): void {
    if (!this.transferDetails?.purchasedItem) {
      this.router.navigate(['/rewards/wallet']);
    }
  }
}
